export default "__VITE_ASSET__DuTUe1DI__"